import { Component, OnInit, Input } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

import { SnackBarConfig } from '../../../shared/configs';

@Component({
  selector: 'lum-rfq-attachments-form',
  templateUrl: './rfq-attachments-form.component.html',
  styleUrls: ['./rfq-attachments-form.component.scss'],
})
export class RfqAttachmentsComponent implements OnInit {
  @Input()
  form :UntypedFormGroup;

  filesToUpload :any[] = [];
  rfqAttachments :any[] = [];
  attachmentsToDelete :any[] = [];

  constructor(
    private fb :UntypedFormBuilder,
    private snackBar :MatSnackBar,
  ) {}

  ngOnInit() :void {}

  onHandleFileInput(event :any) :void {
    const files = Array.prototype.slice.call(event?.target?.files);
    const fileremarks = this.fileMarksControl;
    const instance = this;
    let maxSizeError = false;
    files.forEach((file) => {
      if (file.size > 10000000) {
        maxSizeError = true;
      } else {
        if (file.type.toString().search('image') >= 0) {
          const fReader = new FileReader();
          fReader.readAsDataURL(file);
          fReader.onload = function (e :any) {
            fileremarks.push(
              instance.fb.group({
                remarks: '',
                previewSrc: e.target.result,
                file,
              }),
            );
          };
        }
      }
    });
    if (maxSizeError) {
      this.snackBar.open('File to attach should not exceed 10MB.', 'Error', {
        duration: SnackBarConfig.DEFAULT.duration,
      });
    }

    event.target.value = '';
  }

  onRemoveFile(index :number) :void {
    const fileremarks = this.fileMarksControl;
    if (this.rfqAttachments[index]) {
      this.attachmentsToDelete.push(this.rfqAttachments[index].filename);
    }
    fileremarks.removeAt(index);
    this.rfqAttachments.splice(index, 1);
  }

  get fileMarksControl() :UntypedFormArray {
    return this.form.get('fileremarks') as UntypedFormArray;
  }
}
